import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { t } from 'i18next'

import {
  removeGalleryImage,
  updateGalleryImages,
} from '../../../actions/portal'
import ImagePreview from '../image-preview/ImagePreview'
import withReduxModal, {
  modalPropTypes,
} from '../../../modules/redux-modal/redux/withReduxModal'
import { PORTAL_GALLERY_IMAGE_FORM_MODAL } from '../../../constants/modalType'
import SortableComponent, {
  createSortableItem,
} from '../../views/widgets/SortableComponent'
import ImageEmptySection from '../image-management/ImageEmptySection'
import TruncateWidth from '../../views/widgets/TruncateWidth'

class PortalGalleryImage extends React.Component {
  static propTypes = {
    ...modalPropTypes,
    galleryImages: PropTypes.array.isRequired,
  }

  handleGalleryImageRemove = async imageID => {
    if (window.confirm(t('alert.deleteImage.label'))) {
      this.props.actions.removeGalleryImage(imageID)
    }
  }

  handleSortEnd = galleryImages => {
    this.props.actions.updateGalleryImages(galleryImages)
  }

  showGalleryImageFormModal = imageID => {
    console.log('show gallery image form modal')
    const galleryImage = _.find(this.props.galleryImages, {
      mainImageId: imageID,
    })

    this.props.modalActions.showModal(PORTAL_GALLERY_IMAGE_FORM_MODAL, {
      galleryImage,
    })
  }

  render() {
    if (_.isEmpty(this.props.galleryImages)) {
      return <ImageEmptySection />
    }

    return (
      <SortableComponent
        axis="x"
        items={this.props.galleryImages}
        onSortEnd={this.handleSortEnd}
        renderSortableItem={({ item, ...props }) => (
          <SortableItem
            key={item.mainImageId}
            item={item}
            language={this.props.language}
            {...props}
            onImageSelect={this.showGalleryImageFormModal}
            onImageRemove={this.handleGalleryImageRemove}
          />
        )}
      />
    )
  }
}

const ImagePreviewItem = ({
  item: image,
  onImageSelect,
  onImageRemove,
  language = 'th',
}) => {
  const imageID = _.get(image, 'mainImageId')
  const lastChecked = _.get(image, 'lastChecked')
  const title = _.get(image, `title.${language}`)
  const description = _.get(image, `description.${language}`)
  return (
    <div key={imageID} onClick={() => onImageSelect(imageID)}>
      <ImagePreview
        imageID={imageID}
        lastChecked={lastChecked}
        onImageSelect={onImageSelect}
        onImageRemove={onImageRemove}
      />
      <hr style={{ margin: '4px' }} />
      <div style={{ padding: '4px' }}>
        <TruncateWidth width={180}>
          <strong>
            <i className="fas fa-heading" /> {title || 'N/A'}{' '}
          </strong>
          <p>
            <small>
              <i className="fas fa-list-ul" /> {description || 'N/A'}
            </small>
          </p>
        </TruncateWidth>
      </div>
      <div style={{ padding: 4 }}>
        <a className="button is-default is-small is-fullwidth">
          เพิ่ม/แก้ไข ข้อมูล
        </a>
      </div>
    </div>
  )
}

const SortableItem = createSortableItem(ImagePreviewItem)

export default compose(
  withReduxModal,
  connect(
    ({ portal, info }) => ({
      language: info.language,
      galleryImages: portal.galleryImages,
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          removeGalleryImage: removeGalleryImage,
          updateGalleryImages: updateGalleryImages,
        },
        dispatch,
      ),
    }),
  ),
)(PortalGalleryImage)



// WEBPACK FOOTER //
// ./src/components/templates/portal-gallery-image/PortalGalleryImage.js